// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingEffect2_typingContainer__35ddo","typingText":"TypingEffect2_typingText__qt2ei","cursor":"TypingEffect2_cursor__ctCcd","blink":"TypingEffect2_blink__58BG0"};